var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"distribution"},[_c('div',{staticClass:"head"},[_c('h2',[_vm._v(_vm._s(_vm.title))]),_c('p',[_vm._v(_vm._s(_vm.subtitle))])]),_c('div',{staticClass:"content bg_blue"},[_c('img',{attrs:{"src":_vm.isImgPC ? _vm.imgPC : _vm.imgMobile}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }